module.exports = __webpack_public_path__ + "img/law.08bd14f0.png";